/**
 * Função utilitária para parsear IDs de diferentes formatos.
 * 
 * Aceita dois formatos:
 * 1. Array JSON: ["id1", "id2", "id3"]
 * 2. Múltiplas linhas: id1\nid2\nid3
 * 
 * @param input - String com IDs no formato JSON array ou múltiplas linhas
 * @returns Array de strings com os IDs parseados
 */
export const parseIds = (input: string): string[] => {
  if (!input || !input.trim()) {
    return [];
  }

  const trimmedInput = input.trim();

  // Tenta fazer parse como JSON primeiro
  try {
    const parsed = JSON.parse(trimmedInput);
    
    // Verifica se é um array
    if (Array.isArray(parsed)) {
      // Filtra apenas strings válidas e não vazias
      return parsed
        .map((item) => String(item).trim())
        .filter((item) => item.length > 0);
    }
  } catch (e) {
    // Se não for JSON válido, continua com o formato de múltiplas linhas
  }

  // Se não for JSON, usa o formato de múltiplas linhas (comportamento original)
  return trimmedInput
    .split("\n")
    .map((id) => id.trim())
    .filter((id) => id.length > 0);
};

